import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { logoutUser } from "../../redux/slices"

export const LogoutPage: React.FC = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    const p = dispatch<any>(logoutUser())
    p.finally(() => {
      navigate("/ui2/login", { replace: true })
    })
  }, [dispatch, navigate])

  return <h2>Logging out...</h2>
}